export class VoniError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VoniError';
  }
}

export class VoniAuthError extends VoniError {
  constructor(message: string) {
    super(message);
    this.name = 'VoniAuthError';
  }
}

export class VoniApiError extends VoniError {
  constructor(
    message: string,
    public statusCode?: number,
    public response?: unknown
  ) {
    super(message);
    this.name = 'VoniApiError';
  }
}

export class VoniValidationError extends VoniError {
  constructor(message: string) {
    super(message);
    this.name = 'VoniValidationError';
  }
}
